export default "__VITE_ASSET__BClkj35c__"